import { UserVestingData } from "../../../../types/UserVesting";
import { PRESALE_CONTRACT_ADDRESS, PRESALE_ID } from "../../../constants";
import { checkIfObjectIsUndefined } from "../../../helpers";
import { UserVesting } from "../../../classes/presale-manager/UserVesting";
import { presaleAbi } from "../../../abis/presaleAbi";
import { useAccount, useReadContract } from "wagmi";

export function useUserVesting() {
  const { address } = useAccount();
  const { data, refetch, error, isLoading, isPending, isFetching } =
    useReadContract({
      address: PRESALE_CONTRACT_ADDRESS,
      abi: presaleAbi,
      functionName: "userVesting",
      args: [address as `0x${string}`, PRESALE_ID],
    });

  if (isLoading && isPending && isFetching) return null;

  if (error) {
    console.log(error);
    return null;
  }

  const parsedData = {
    totalAmount: data?.[0],
    claimedAmount: data?.[1],
    claimStart: data?.[2],
    claimEnd: data?.[3],
  } as UserVestingData;

  const isDataUndefined = checkIfObjectIsUndefined(parsedData);

  if (isDataUndefined || !refetch) return null;

  const userVesting = new UserVesting(parsedData);
  return { data: userVesting, refetchUserVesting: refetch };
}
